import { toast } from 'react-toastify';
import FileUploadAPI from '../FileUploadAPI';
export const FileDelete = (file_id,upload_id) => {
    return new Promise((resolve) => {
        FileUploadAPI.post(`/files/delete?file_id=${encodeURIComponent(file_id)}&upload_id=${encodeURIComponent(upload_id)}`)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            toast.error("Something went wrong")
            console.log(error)
          });
    })
}